import { createContext } from "react";

import type React from "react";

export type Tab = {
  name: string;
  ref: React.RefObject<HTMLDivElement>;
};

export type TabsContextType = {
  tabs: Tab[];
  isActive: (name: string) => boolean;
  setTabs: React.Dispatch<React.SetStateAction<Tab[]>>;
  activeTab?: Tab;
  handleChange: (name: string) => any;
};

export const TabsContext = createContext<TabsContextType>({
  tabs: [],
  isActive: (name: string) => !!name,
  setTabs: () => {},
  handleChange: (name: string) => name,
});
